// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

import { Route } from "@angular/router";
import { GuestLayoutComponent } from "./common/layouts/guest-layout/guest-layout.component";
import { GuestWhiteComponent } from "./common/layouts/guest-white/guest-white.component";
import { UserLayoutComponent } from "./common/layouts/user-layout/user-layout.component";
import { AuthGuard } from "./services/auth/guards/auth.guard.service";
import { NoAuthGuard } from "./services/auth/guards/no-auth.guard.service";
import { ShopComponent } from "./modules/user/old-components/shop/shop.component";
import { AssetsComponent } from "./modules/user/old-components/assets/assets.component";
import { AssetDetailsComponent } from "./modules/user/old-components/assets/details/details.component";
import { KryptomonsComponentOLD } from "./modules/user/old-components/kryptomons/kryptomons.component";
import { DetailsComponent } from "./modules/user/old-components/kryptomons/details/details.component";
import { BreedingCenterComponent } from "./modules/user/old-components/breeding-center/breeding-center.component";
import { StakingComponent } from "./modules/user/old-components/staking/staking.component";
import { MerchandiseComponent } from "./modules/user/old-components/merchandise/merchandise.component";
import { ReferralComponent } from "./modules/user/old-components/referral/referral.component";
import { ClaimComponent } from "./modules/user/old-components/claim/claim.component";
import { WizardComponent } from "./modules/user/old-components/wizard/wizard.component";
import { RentingHouseComponent } from "./modules/user/old-components/renting-house/renting-house.component";
import { PlayComponent } from "./modules/user/old-components/play/play.component";
import { CommunityComponent } from "./modules/user/old-components/community/community.component";
import { AcademyComponent } from "./modules/user/old-components/academy/academy.component";
import { KmonComponent } from "./modules/user/old-components/kmon/kmon.component";
import { OnboardingComponent } from "./modules/user/old-components/onboarding/onboarding.component";
import { StartComponent } from "./modules/user/old-components/onboarding/start/start.component";
import { FindComponent } from "./modules/user/old-components/onboarding/find/find.component";
import { BalancefillComponent } from "./modules/user/old-components/onboarding/balancefill/balancefill.component";
import { FirstLootboxComponent } from "./modules/user/old-components/onboarding/first-lootbox/first-lootbox.component";
import { CompleteComponent } from "./modules/user/old-components/onboarding/complete/complete.component";
import { F2pNewComponent } from "./modules/user/old-components/onboarding/f2p-new/f2p-new.component";
import { OnboardingLayoutComponent } from "./common/layouts/onboarding-layout/onboarding-layout.component";
import { MbSaleComponent } from "./modules/user/old-components/mb-sale/mb-sale.component";
import { MigrationLayoutComponent } from "./common/layouts/migration-layout/migration-layout.component";
import { KryptomonsResolver } from "./modules/user/kryptomons/kryptomons.resolver";


export const appRoutes: Route[] = [

    { path: '', pathMatch: 'full', redirectTo: 'sign-in' },

    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect-user', pathMatch: 'full', redirectTo: 'welcome' },
    { path: 'login', pathMatch: 'full', redirectTo: 'sign-in' },
    { path: 'signin', pathMatch: 'full', redirectTo: 'sign-up' },
    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: GuestLayoutComponent,
        children: [
            { path: 'sign-in', loadChildren: () => import('app/modules/guest/sign-in/sign-in.module').then(m => m.SignInModule), data: { skipCookieCheck: true } },
            { path: 'sign-up', loadChildren: () => import('app/modules/guest/sign-up/sign-up.module').then(m => m.SignUpModule), data: { skipCookieCheck: true } },
        ]
    },

    // Auth routes for authenticated user
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: UserLayoutComponent,
        children: [
            // all routes with lazy loading are ready to be deployed, active them when old componet will be replaced
            //My Assets
            {
                path: 'kryptomons',
                resolve: { kryptomonsData: KryptomonsResolver },
                children: [
                    { path: '', loadChildren: () => import('app/modules/user/kryptomons/kryptomons.module').then(m => m.KryptomonsModule) },
                    { path: ':id', loadChildren: () => import('app/modules/user/kryptomons/kryptomon-detail/kryptomon-detail.module').then(m => m.KryptomonDetailModule) }

                ]
            },
            // { path: 'items', loadChildren: () => import('app/modules/user/items/items.module').then(m => m.ItemsModule) },
            // { path: 'wallet', loadChildren: () => import('app/modules/user/wallet/wallet.module').then(m => m.WalletModule) },
            { path: 'breeding-center', loadChildren: () => import('app/modules/user/breeding-center/breeding-center.module').then(m => m.BreedingCenterModule) },
            //Rewards
            { path: 'spin-the-wheel', loadChildren: () => import('app/modules/user/spin-the-wheel/spin-the-wheel.module').then(m => m.SpinTheWheelModule) },
            // { path: 'staking', loadChildren: () => import('app/modules/user/staking/staking.module').then(m => m.StakingModule) },
            // { path: 'referral', loadChildren: () => import('app/modules/user/referral/referral.module').then(m => m.ReferralModule) },
            // { path: 'claim-reward', loadChildren: () => import('app/modules/user/claim-reward/claim-reward.module').then(m => m.ClaimRewardModule) },
            //Marketplace
            // { path: 'marketplace-kryptomons', loadChildren: () => import('app/modules/user/marketplace/marketplace.module').then(m => m.MarketplaceModule) },
            // { path: 'auction-house', loadChildren: () => import('app/modules/user/auction-house/auction-house.module').then(m => m.AuctionHouseModule) },
            // { path: 'renting-house', loadChildren: () => import('app/modules/user/renting-house/renting-house.module').then(m => m.RentingHouseModule) },
            //Shop
            { path: 'primus-bazaar', pathMatch: 'full', redirectTo: 'primus-bazaar/company-store' },
            {
                path: 'primus-bazaar',
                // resolve: { kryptomonsData: PrimusBazaarResolver },
                // component: PrimusBazaarComponent,
                children: [
                    { path: '', loadChildren: () => import('app/modules/user/primus-bazaar/primus-bazaar.module').then(m => m.PrimusBazaarModule) },
                    // { path: ':id', loadChildren: () => import('app/modules/user/primus-bazaar/primus-bazaar-detail/primus-bazaar-detail.module').then(m => m.PrimusBazaarDetailModule) }
                    // { path: '', loadChildren: () => import('app/modules/user/primus-bazaar/company-store/company-store.module').then(m => m.CompanyStoreModule) },
                    { path: 'company-store/:id', loadChildren: () => import('app/modules/user/primus-bazaar/company-store/company-store-detail/company-store-detail.module').then(m => m.CompanyStoreDetailModule) },
                    { path: 'auction-house/:id', loadChildren: () => import('app/modules/user/primus-bazaar/auction-house/auction-house-detail/auction-house-detail.module').then(m => m.AuctionHouseDetailModule) }
                ]
            },
            {
                path: 'armor-scraps',
                children: [
                    { path: '', loadChildren: () => import('app/modules/user/items/armor-scraps-details/armor-scraps-details.module').then(m => m.ArmorScrapsDetailsModule) },
                ]
            },
            {
                path: 'quick-craft',
                children: [
                    { path: '', loadChildren: () => import('app/modules/user/items/quick-craft/quick-craft.module').then(m => m.QuickCraftModule) },
                ]
            },
            // { path: 'merchandise', loadChildren: () => import('app/modules/user/merchandise/merchandise.module').then(m => m.MerchandiseModule) },
            //Resources
            // { path: 'communities', loadChildren: () => import('app/modules/user/communities/communities.module').then(m => m.CommunitiesModule) },
            // { path: 'academy', loadChildren: () => import('app/modules/user/academy/academy.module').then(m => m.AcademyModule) },
            //tcg Dashboard
            { path: 'tcg-dash', pathMatch: 'full', redirectTo: 'hunters' },
            {
                path: 'hunters',
                children: [
                    { path: '', loadChildren: () => import('app/modules/user/tcg-dash/tcg-dash.module').then(m => m.TcgDashModule) },
                    { path: 'claim', loadChildren: () => import('app/modules/user/tcg-dash/tcg-claim/tcg-claim.module').then(m => m.TcgClaimModule), }
                ]
            },
            { path: 'wok', loadChildren: () => import('app/modules/user/wok/wok.module').then(m => m.WokModule) },
            { path: 'sapphire-claim', loadChildren: () => import('app/modules/user/golden-egg-claim/golden-egg-claim.module').then(m => m.GoldenEggClaimModule) },

            //OLD ROUTES
            // { path: 'kryptomons-old', component: KryptomonsComponentOLD },
            // { path: 'kryptomons-old/details/:id', component: DetailsComponent },
            { path: 'assets', component: AssetsComponent },
            { path: 'assets/details/:id', component: AssetDetailsComponent },
            { path: 'shop/:route/:id/:addon', component: ShopComponent },
            { path: 'shop/:route/:id', component: ShopComponent },
            { path: 'shop/:id', component: ShopComponent },
            { path: 'shop', component: ShopComponent },
            { path: 'breeding/:id', component: BreedingCenterComponent },
            { path: 'breeding', component: BreedingCenterComponent },
            { path: 'staking', component: StakingComponent },
            { path: 'merchandise', component: MerchandiseComponent },

            { path: 'referral', component: ReferralComponent },
            { path: 'rewards-claim', component: ClaimComponent },
            { path: 'marketplace', component: WizardComponent },
            { path: 'marketplace/:url', component: WizardComponent },
            { path: 'renting-house', component: RentingHouseComponent },
            { path: 'renting-house/:id', component: RentingHouseComponent },
            { path: 'play', component: PlayComponent },
            { path: 'communities', component: CommunityComponent },
            { path: 'academy', component: AcademyComponent },
            { path: 'wallet', component: KmonComponent },
            { path: 'sale', component: MbSaleComponent },


        ]
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: OnboardingLayoutComponent,
        children: [
            {
                path: 'onboarding', component: OnboardingComponent, children: [
                    { path: '', redirectTo: 'start', pathMatch: 'full' },
                    { path: 'start', component: StartComponent },
                    { path: 'find', component: FindComponent },
                    { path: 'balancefill', component: BalancefillComponent },
                    { path: 'first-lootbox', component: FirstLootboxComponent },
                    { path: 'staking', component: StakingComponent },
                    { path: 'complete', component: CompleteComponent },
                    { path: 'pick-starter', component: F2pNewComponent }
                ]
            },
            //welcome page
            { path: 'welcome', loadChildren: () => import('app/modules/user/welcome-page/welcome-page.module').then(m => m.WelcomePageModule) },
        ]
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: MigrationLayoutComponent,
        children: [
            { path: 'migrate-to-polygon', loadChildren: () => import('app/modules/user/migration-polygon/migration-polygon.module').then(m => m.MigrationPolygonModule) }
        ]
    }, {
        path: 'leaderboard',
        //canActivate: [NoAuthGuard],
        //canActivateChild: [NoAuthGuard],
        component: GuestWhiteComponent,
        children: [
            { path: '', loadChildren: () => import('app/modules/guest/leaderboard/leaderboard.module').then(m => m.LeaderboardModule), data: { skipCookieCheck: true } },
        ]
    },{
        path: 'open-sale',
        //canActivate: [NoAuthGuard],
        //canActivateChild: [NoAuthGuard],
        component: GuestWhiteComponent,
        children: [
            { path: '', loadChildren: () => import('app/modules/guest/sales/sales.module').then(m => m.SalesModule), data: { skipCookieCheck: true } },
        ]
    },{
        path: 'guest/sapphire-claim',
        //canActivate: [NoAuthGuard],
        //canActivateChild: [NoAuthGuard],
        component: GuestWhiteComponent,
        children: [
            { path: '', loadChildren: () => import('app/modules/user/golden-egg-claim/golden-egg-claim.module').then(m => m.GoldenEggClaimModule), data: { skipCookieCheck: true } },
        ]
    },{
        path: 'wok_signup_success',
        //canActivate: [NoAuthGuard],
        //canActivateChild: [NoAuthGuard],
        component: GuestWhiteComponent,
        children: [
            { path: '', loadChildren: () => import('app/modules/guest/wok-signup-success/wok-signup-success.module').then(m => m.WokSignupSuccessModule), data: { skipCookieCheck: true } },
        ]
    }
];